import React from 'react'
import './klang_m.css'


export default function Klang(props) {

    var titel = props.titel;
    var interpret = props.interpret;
    var text = props.text;
    var link = props.link;

    return (
        <div className="klang_m">
            <div className="klang_title_m"> {titel} </div>
            <em className="klang_interpret_m">{interpret}</em>
            <div className="klang_text_m">{text}</div>
            <div style={{color: 'white'}}>
            <a href={link} target="_blank" className="klang_btn_m btn-accent_m">LIED HÖREN </a>
            </div>
        </div>
    )
}
